module.exports = __webpack_public_path__ + "img/108.partial_Information.ae419c2e.svg";